// extracted by mini-css-extract-plugin
module.exports = {"root":"style_root__tAJGz g-grid-container","logos":"style_logos__WYgMV"};